var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import cloneDeep from 'lodash/cloneDeep';
import constants from './constants';

var PANE_OPTIONS = {
    size: '0%'
};

var SOLIDGAUGECHART_PANE_OPTIONS = {
    center: ['50%', '80%'],
    size: '130%',
    startAngle: -90,
    endAngle: 90,
    background: {
        innerRadius: '50%',
        outerRadius: '100%',
        shape: 'arc'
    }
};

var GAUGESERIES_PANE_OPTIONS = {
    startAngle: -150,
    endAngle: 150
};

var RADIALBAR_PANE_OPTIONS = {
    size: '85%',
    innerSize: '20%',
    startAngle: 0,
    endAngle: 270
};

var configurePane = function configurePane(widgetConfig, customConfig) {
    var ChartConfig = widgetConfig.ChartConfig,
        GaugeConfig = widgetConfig.GaugeConfig;

    if (!ChartConfig) {
        if (GaugeConfig && GaugeConfig.GaugeType.toLowerCase() === constants.chartTypes.SOLIDGAUGE) return SOLIDGAUGECHART_PANE_OPTIONS;else if (GaugeConfig && GaugeConfig.GaugeType.toLowerCase() === constants.chartTypes.GAUGESERIES) return GAUGESERIES_PANE_OPTIONS;
        return null;
    } else {
        if (ChartConfig.ChartType.toLowerCase() === constants.chartTypes.RADIALBAR) return RADIALBAR_PANE_OPTIONS;else if (ChartConfig.ChartType.toLowerCase() === constants.chartTypes.FUNNEL || ChartConfig.ChartType.toLowerCase() === constants.chartTypes.PYRAMID) return {};
    }
    var config = cloneDeep(PANE_OPTIONS);
    config = _extends({}, config, cloneDeep(customConfig));
    return config;
};

export default configurePane;